import { strictDraftRequest } from "./drafts";

const root = "api/v1/organisation/hr";
const segment = (value) => encodeURIComponent(value);
export const hrApi = {
  list: (resource, params = {}) => {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== "" && value !== undefined && value !== null) query.set(key, value);
    });
    return strictDraftRequest(`${root}/${segment(resource)}?${query}`);
  },
  save: (resource, body, id) => strictDraftRequest(`${root}/${segment(resource)}${id ? `/${segment(id)}` : ""}`, { method: id ? "PUT" : "POST", body }),
  action: (resource, id, action, body) => strictDraftRequest(`${root}/${segment(resource)}/${segment(id)}/${segment(action)}`, { method: "POST", body }),
  history: (resource, id, page = 1) => strictDraftRequest(`${root}/${segment(resource)}/${segment(id)}/${resource === "assets" ? "history" : "corrections"}?page=${page}&count=20`),
};